var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgFenced = function SvgSvgFenced(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19,
    fill: "none",
    viewBox: "0 0 24 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.5 19c-.827 0-1.5-.673-1.5-1.5V16h-3v1.5c0 .827-.673 1.5-1.5 1.5h-3c-.827 0-1.5-.673-1.5-1.5V16H6v1.5c0 .827-.673 1.5-1.5 1.5h-3C.673 19 0 18.327 0 17.5V3.25c0-1.654 1.346-3 3-3s3 1.346 3 3V5.5h3V3.25c0-1.654 1.346-3 3-3s3 1.346 3 3V5.5h3V3.25c0-1.654 1.346-3 3-3s3 1.346 3 3V17.5c0 .827-.673 1.5-1.5 1.5zM21 1.75c-.827 0-1.5.673-1.5 1.5V17.5h3V3.25c0-.827-.673-1.5-1.5-1.5m-9 0c-.827 0-1.5.673-1.5 1.5V17.5h3V3.25c0-.827-.673-1.5-1.5-1.5m-9 0c-.827 0-1.5.673-1.5 1.5V17.5h3V3.25c0-.827-.673-1.5-1.5-1.5M18 14.5V7h-3v7.5zm-9 0V7H6v7.5z"
  })));
};
export default SvgSvgFenced;